const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PEDIDO_PRAZO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'PEDIDO_PRAZO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'PEDIDO_PRAZO_LISTADO':
            return {
				...state,
				lista: action.payload.data,
				listaSelect: action.payload.data.map(item => ({
					...item,
					valor: item.nome
				}))
			};

        default:
            return state;
    }
}
